import React from 'react';
import {View} from 'react-native';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {MetricsSection} from '/constant/TestIDs';

import {styles} from './MetricSection.style';

interface MetricItemProps {
  item: {
    label: string;
    value: number;
    testID?: string;
  };
}

export const PlainMetricItem: React.FC<MetricItemProps> = ({item}) => {
  const {label, value, testID} = item;
  return (
    <View
      testID={testID}
      style={styles.listItem}
      // accessible={true}
      // accessibilityLabel={getTextFromReactNode(label)}
    >
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        accessible={true}
        testID={MetricsSection.metricTitle}
        emphasis="high"
        style={styles.listItemLabel}>
        {label}
      </Text>
      <FormattedNumber
        accessible={true}
        testID={MetricsSection.metricValue}
        truncate
        value={value}
      />
    </View>
  );
};

export default PlainMetricItem;
